import { getFromLocalStorage, setToLocalStorage } from "@/lib/safeLocalStorage";
import { captureException } from "@sentry/nextjs";
import dayjs from "dayjs";
import { isoDate, pipe, safeParse, string } from "valibot";

const LAST_REQUEST_PROGRAM_KEY = "lastRequestProgram";
const REQUEST_PROGRAM_KEY = "request_program";

export const LastRequestProgramSchema = pipe(string(), isoDate());

export const getLastRequestProgram = (): dayjs.Dayjs | null => {
  try {
    const lastRequestProgram = safeParse(LastRequestProgramSchema, getFromLocalStorage(LAST_REQUEST_PROGRAM_KEY));
    if (lastRequestProgram.success) return dayjs(lastRequestProgram.output);
    return null;
  } catch (error) {
    captureException(error);
    return null;
  }
};

export const setLastRequestProgram = (): void => {
  try {
    setToLocalStorage(LAST_REQUEST_PROGRAM_KEY, dayjs().format("YYYY-MM-DD"));
  } catch (error) {
    captureException(error);
  }
};

export const hasRequestedProgram = (): boolean => {
  try {
    return getFromLocalStorage(REQUEST_PROGRAM_KEY) === "true";
  } catch (error) {
    captureException(error);
    return false;
  }
};

export const setRequestProgram = (): void => {
  try {
    setToLocalStorage(REQUEST_PROGRAM_KEY, "true");
  } catch (error) {
    captureException(error);
  }
};
